import { useEffect, useCallback } from 'react'
import useNotes from '@/v2/hooks/useNotes'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { useUpdateAppointment } from '@/v2/hooks/useAppointment'

export const useSaveNote = appointmentId => {
  const { mutationCreate, mutationUpdate } = useNotes()
  const { onOpenSnackbar } = useSnackbarContext()

  const { mutate: createNote, error: createNoteError } = mutationCreate
  const { mutate: editNote, error: editNoteError } = mutationUpdate

  const { updateAppointment } = useUpdateAppointment({ appointmentId })

  useEffect(() => {
    if (!!createNoteError || !!editNoteError) {
      onOpenSnackbar('Something went wrong when saving notes!', 'error')
    }
  }, [createNoteError, editNoteError, onOpenSnackbar])

  const saveNote = useCallback(
    async ({ value, doctor, edit, id }) => {
      try {
        if (edit) {
          const newNote = { id, doctor: doctor.id, note: value }
          // If the note does not exist yet (id === 0), update the appointment notes.
          if (id === 0) {
            const updatedAppointmentRes = await updateAppointment({
              id: appointmentId,
              notes: value,
            })
            if (updatedAppointmentRes.errors) {
              throw new Error(updatedAppointmentRes.errors)
            }
          } else {
            const apptId = appointmentId.appointmentId
            await editNote({ ...newNote, appointmentId: apptId })
          }
        } else {
          const apptId = appointmentId.appointmentId
          await createNote(
            { doctor: doctor.id, note: value, appointmentId: apptId },
            () => {
              onOpenSnackbar('Created note.')
            }
          )
        }
      } catch (e) {
        onOpenSnackbar('Something went wrong when saving notes!', 'error')
      }
    },
    [createNote, editNote, onOpenSnackbar, updateAppointment, appointmentId]
  )

  return { saveNote }
}
